import { faPrint } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, Select } from 'antd';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import styled, { createGlobalStyle } from 'styled-components';
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import { flatten, isEmpty, last, omit, values } from 'lodash';
import { PrintContent } from './PrintContent';
import { useSelector } from '@redux';
import { genOrderTemplate } from 'templates/phieuxuatkho';
import { genLargeLabelPackage } from 'templates/largeLabelPackage';
import { genSmallLabelPackage } from 'templates/smallLabelPackage';
import { DynamicObjectType } from 'types/commons';
import { lotDatePattern } from 'constants/constants';

const PRINT_CONTENT: any = {
  printDeliveryBill: genOrderTemplate,
  printLabelBig: genLargeLabelPackage,
  printLabelSmall: genSmallLabelPackage,
};

const PRINT_SIZE = {
  printDeliveryBill: undefined,
  printLabelBig: `@page {
    size: 10cm 15cm;
    color: #000  !important;
  }`,
  printLabelSmall: `@page {
    size: 4in 4in;
    color: #000  !important;
  }`,
};

const PrintLabelActions = (
  {
    printActions = [],
    orders = {},
    selectedRowKeys = [],
    visible,
    setVisible,
    initPrintType,
  },
  ref,
) => {
  console.log(orders);
  const { t } = useTranslation();
  const [selected, setSelected] = useState();
  // const [visible, setVisible] = useState(false);
  const currentBatch = useSelector((state) => state.orderBatches.currentData);

  const printViewRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printViewRef.current,
  });

  const selectPrint = (type) => {
    setSelected(type);
    // setVisible(true);
  };

  useImperativeHandle(ref, () => ({}), []);

  useEffect(() => {
    initPrintType && setSelected(initPrintType);
  }, [initPrintType]);

  if (
    Object.keys(orders)?.length === 1 &&
    (values(orders)?.[0] as DynamicObjectType)?.shippingLabelUrlPdf
  ) {
    return (
      <ModalWrapper
        title={t('orders.reviewPrint')}
        onCancel={() => setVisible(false)}
        destroyOnClose
        open={visible}
        width="100vw"
        
        classNames={{content:'top-0 h-[98vh]', wrapper:'top-0 !overflow-hidden', body: 'h-[90vh] !max-h-[100vh]' }}
        // footer={[
        //   <Button
        //     key="print"
        //     onClick={() =>
        //       (document.getElementById('print-iframe') as HTMLIFrameElement)?.contentWindow?.print()
        //     }
        //     type="primary"
        //     className="!text-white"
        //     icon={<FontAwesomeIcon className="!text-white" icon={faPrint} />}
        //   >
        //     PRINT
        //   </Button>,
        // ]}
        footer={null}
      >
        <iframe
          id="print-iframe"
          src={
            (values(orders)?.[0] as DynamicObjectType)?.shippingLabelUrlPdf ||
            ''
          }
          height="100%"
          width="100%"
        />
      </ModalWrapper>
    );
  }

  return (
    <>
      {/* {printActions.map((e) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
            selectPrint(e);
          }}
        >
          {t(`orders.button.${e}`)}
        </div>
      ))} */}
      {/* <div>{t(`Print label`)}</div> */}
      <ModalWrapper
        title={t('orders.reviewPrint')}
        footer={null}
        onCancel={() => setVisible(false)}
        destroyOnClose
        open={visible}
        width="23cm"
        {...(!!selected && {
          footer: [
            <Button
              key="print"
              onClick={handlePrint}
              type="primary"
              className="!text-white"
              icon={<FontAwesomeIcon className="!text-white" icon={faPrint} />}
            >
              PRINT
            </Button>,
          ],
        })}
      >
        <Select
          options={printActions?.map((e) => ({
            label: t(`orders.button.${e}`),
            value: e,
          }))}
          onChange={(e) => selectPrint(e)}
          className={`w-[200px] mb-2.5 ${initPrintType === 'printDeliveryBill' ? 'hidden' : ''}`}
          value={selected || initPrintType}
        />
        <div className="d-flex column center text-align:right;">
          {!!selected && (
            <>
              <ReactToPrint
                // trigger={() => <button>Print this out!</button>}
                content={() => printViewRef.current}
                pageStyle={PRINT_SIZE[selected]}
              />
              <div ref={printViewRef}>
                {visible && !isEmpty(orders) && selectedRowKeys?.length > 0 && (
                  <PrintContent
                    orders={orders}
                    selectedRowKeys={selectedRowKeys}
                    selected={selected}
                    content={selectedRowKeys.map((e) => {
                      return PRINT_CONTENT[selected]?.(
                        {
                          ...orders?.[e],
                          items: flatten(
                            orders?.[e]?.items?.map((e) => {
                              return [
                                ...(e?.product?.comboItems?.length > 0
                                  ? e?.product?.comboItems?.map(
                                      (comboItem) => ({
                                        ...comboItem?.product,
                                        ...comboItem,
                                        quantity:
                                          +comboItem?.quantity * +e?.quantity,
                                        comboProduct: omit(e, ['comboItems']),
                                        isComboItem: true,
                                        name: comboItem.productName,
                                        currency: 'đ',
                                        thumbnail:
                                          comboItem?.variant?.thumbnail ||
                                          comboItem.productThumbnail ||
                                          comboItem?.propduct?.thumbnail,
                                      }),
                                    ) || []
                                  : [
                                      {
                                        ...e,
                                        name: e.productName,
                                        quantity: e.quantity,
                                        price: Number(e.price),
                                        currency: 'đ',
                                        thumbnail:
                                          e?.variant?.thumbnail ||
                                          e.productThumbnail ||
                                          e?.propduct?.thumbnail,
                                        // comboItems: ,
                                      },
                                    ]),
                              ];
                            }) || [],
                          )?.map((item: DynamicObjectType) => {
                            const lotDate: string = last(
                              item?.variant?.sku?.split('_'),
                            );
                            const isHasLotDate = lotDatePattern.test(lotDate);
                            const variantSku = isHasLotDate
                              ? item?.variant?.sku?.replace(`_${lotDate}`, '')
                              : item?.variant?.sku;

                            return {
                              ...item,
                              ...orders[
                                e
                              ]?.dataFromErp?.OrderCreateResult?.Lines?.find(
                                (erp) =>
                                  `${erp?.ItemId}${
                                    erp?.VariantId ? `_${erp?.VariantId}` : ''
                                  }` === variantSku,
                              ),
                            };
                          }),
                        },
                        currentBatch,
                      );
                    })}
                  />
                )}
              </div>
            </>
          )}
          {selected === 'printLabelSmall' && <GlobalStyleForPrintSmall />}
          {selected === 'printLabelBig' && <GlobalStyleForPrintLabelLarge />}
        </div>
      </ModalWrapper>
    </>
  );
};

export default forwardRef(PrintLabelActions);

const GlobalStyleForPrintSmall = createGlobalStyle`
@media print {
    @page {
      size: 4in 4in;
      margin: 0;
    }
}
    @page {
      size: 4in 4in;
      margin: 0;
    }
    `;

const GlobalStyleForPrintLabelLarge = createGlobalStyle`
    @media print {
        @page {
          size: 10cm 15cm;
          margin: 0;
        }
    }
        @page {
          size: 10cm 15cm;
          margin: 0;
        }
        `;

const ModalWrapper = styled(Modal)`
  .ant-modal-body {
    max-height: 60vh;
    overflow: auto;
    * {
      font-family: Poppins, sans-serif !important;
      color: #000 !important;
    }
  }
  * {
    font-family: Poppins, sans-serif !important;
    color: #000 !important;
  }
`;
